import { CommandBar, ICommandBarItemProps } from "@fluentui/react";
import { useMemo } from "react";

import { IMeta } from "@/core/libs/api/interfaces/meta.interface";

interface TableCommandBarProps {
  hasFilters: boolean;
  onPageChange: (page: number) => void;
  onToggleFilters: () => void;
  onResetFilters: () => void;
  meta?: IMeta;
}

export function TableCommandBar({
  hasFilters,
  onPageChange,
  onToggleFilters,
  onResetFilters,
  meta
}: TableCommandBarProps): JSX.Element {
  const currentPage = meta?.currentPage || 1;
  const totalPages = meta?.totalPages || 1;
  const totalItems = meta?.totalItems || 0;

  const isFirstPage = currentPage === 1 || totalItems === 0;
  const isLastPage = currentPage === totalPages || totalItems === 0;

  const navigationItems = useMemo<Array<ICommandBarItemProps>>(
    () => [
      {
        key: "back",
        text: "Anterior",
        disabled: isFirstPage,
        iconProps: { iconName: "Back" },
        onClick: () => onPageChange(currentPage - 1)
      },
      {
        key: "next",
        text: "Próxima",
        disabled: isLastPage,
        iconProps: { iconName: "Forward" },
        onClick: () => onPageChange(currentPage + 1)
      }
    ],
    [currentPage, isFirstPage, isLastPage, onPageChange]
  );

  const filterItems = useMemo<Array<ICommandBarItemProps>>(() => {
    if (!hasFilters) return [];

    return [
      {
        key: "filter",
        text: "Filtros",
        ariaLabel: "Filtros",
        iconOnly: true,
        iconProps: { iconName: "Filter" },
        onClick: onToggleFilters
      },
      {
        key: "cleanFilters",
        text: "Limpar Filtros",
        ariaLabel: "Limpar Filtros",
        iconOnly: true,
        iconProps: { iconName: "ClearFilter" },
        onClick: onResetFilters
      }
    ];
  }, [hasFilters, onToggleFilters, onResetFilters]);

  return (
    <CommandBar
      items={navigationItems}
      farItems={filterItems}
      styles={{
        root: {
          padding: 0
        }
      }}
    />
  );
}
